export class ChargeTransactionsForGroup {
  Company: string;
  Address: string;
  AccountCode: string;
  So: string;
  InvoiceNo: string;
  PO: string;
  ChargeDate: Date;
  ChargeTypeName: string;
  Description: string;  
  Amount: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/invoice-charge-transactions-for-group.ts